import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Layout from './Layout';
import Login from './Screens/auth/Login';
import SignUp from './Screens/auth/SignUp';
import Dashboard from './Screens/dashboard/Dashboard';
import ProblemTable from './Screens/problem/ProblemTable';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserByToken } from './apis/authSlice';
import { getAuthToken, isTokenExpired, removeAuthToken } from './common/common';
import DocProblemTable from './Screens/problem/DocProblemTable';
import CalenderScreen from './Screens/calender/CalenderScreen';
import DoctorAppointmentTable from './Screens/appointment/DoctorAppointmentTable';
import PatientAppointmentTable from './Screens/appointment/PatientAppointmentTable';
import ChatScreen from './Screens/chat/ChatScreen';
import { useSocket } from './SocketContext';
import { toast } from 'react-toastify';
import { addPatitentAppt, updatePatitentAppt } from './apis/appointmentSlice';
import { addNotification, getUnreadMsgsCount, updateUnreadMsgCount } from './apis/notificationSlice';
import { addPatitentPrb } from './apis/problemSlice';
import Patients from './Screens/patients/Patients';
import Doctors from './Screens/doctors/Doctors';
import PatientForm from './Screens/patientForm/PatientForm';
import AssesstmentForm from './Screens/assesstmentform/AssesstmentForm';
import AppointmentPage from './Screens/appointment/AppointmentPage';
import DoctorSpecialities from './Screens/doctors/DoctorSpecialities';
import PatientCalendar from './Screens/appointment/PatientCalender';
import AppointmentCalender from './Screens/appointment/AppointmentCalender';
import DoctorUnavailability from './Screens/doctors/DoctorUnavailability';
import ExpensePage from './Screens/expense/ExpensePage';
import Medicine from './Screens/medicine/Medicine';
import Clinic from './Screens/clinic/Clinic';
import PharmacyShop from './Screens/pharmacy/PharmacyShop';
import ImportMedicine from './Screens/medicine/ImportMedicine';
import AdditionalService from './AdditionalService/AdditionalService';
import ThemeSettings from './Screens/theme/ThemeSettings';
import PatientPHIList from './Screens/patientPHI/PatientPHIList';
import PatientPHIForm from './Screens/patientPHI/PatientPHIForm';
import PatientPHIDetail from './Screens/patientPHI/PatientPHIDetail';
import { hydrateTheme } from './apis/themeSlice';
import { applyThemeVariables, loadThemeForUser, saveThemeForUser } from './theme/themeUtils';

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const socket = useSocket();

  const [greeting, setGreeting] = useState('');

  const { loggedIn } = useSelector((state) => state.authData);
  const { theme, defaultTheme } = useSelector((state) => state.themeData);

  useEffect(() => {
    if (!location.pathname.startsWith('/login') && !location.pathname.startsWith('/signup') && !location.pathname.startsWith('/patientcalendar')) {
      const handleClick = () => {
        const checkToken = isTokenExpired(getAuthToken());
        // console.log(checkToken);
        if (checkToken) {
          navigate('/login');
          toast.error('Time Out');
        }
        // checkTokenAndNavigate();
      };
      document.addEventListener('click', handleClick);
      return () => {
        document.removeEventListener('click', handleClick);
      };
    }
  }, [navigate]);

  useEffect(() => {
    async function callAPI() {
      const response = await dispatch(getUserByToken());
      // console.log(response);
      if (response.type.includes('rejected') && response.payload.response.data.error) {
        removeAuthToken();
        navigate('/login');
      }
    }
    callAPI();
  }, []);

  useEffect(() => {
    if (!loggedIn) return;
    const userThemeState = loadThemeForUser(loggedIn);
    dispatch(hydrateTheme(userThemeState));
  }, [dispatch, loggedIn]);

  useEffect(() => {
    applyThemeVariables(theme);
  }, [theme]);

  useEffect(() => {
    if (!loggedIn) return;
    saveThemeForUser(loggedIn, { theme, defaultTheme });
  }, [loggedIn, theme, defaultTheme]);

  // console.log('loggedIn-----', loggedIn);

  // useEffect(() => {
  //   if (!socket) return; // Ensure socket is defined before proceeding

  //   if (loggedIn) {
  //     dispatch(getUnreadMsgsCount(loggedIn?._id));

  //     socket.on('notifyUser', (notification) => {
  //       // console.log(notification);
  //       if (notification.receiverId === loggedIn?._id) {
  //         // setNotification((oldNotification) => [...oldNotification, notification.message]);
  //         toast.info(notification.title);
  //         dispatch(addNotification(notification));
  //         dispatch(updateUnreadMsgCount());
  //       }
  //     });

  //     if (loggedIn.role === 'D') {
  //       const docId = loggedIn._id;
  //       socket.emit('joinRoom', docId);

  //       socket.on('newProblem', (data) => {
  //         toast.info(`${data?.data?.patientName}'s new problem ${data?.data?.issue}`);
  //         dispatch(addPatitentPrb(data?.data));
  //       });

  //       return () => {
  //         socket.off('newProblem');
  //       };
  //     } else if (loggedIn.role === 'U') {
  //       const patientId = loggedIn._id;
  //       socket.emit('joinRoom', patientId);

  //       socket.on('newAppointment', (data) => {
  //         toast.info(`${data?.message}`, {
  //           position: 'top-center',
  //           style: { width: '600px' },
  //         });
  //         if (data?.type === 'add') {
  //           dispatch(addPatitentAppt(data?.data));
  //         } else if (data?.type === 'update') {
  //           dispatch(updatePatitentAppt(data?.data));
  //         }
  //       });

  //       return () => {
  //         socket.off('newAppointment');
  //       };
  //     }
  //   }
  // }, [socket, loggedIn]);

  useEffect(() => {
    const updateGreeting = () => {
      const currentHour = new Date().getHours();
      if (currentHour < 12) {
        setGreeting('Good Morning');
      } else if (currentHour < 18) {
        setGreeting('Good Afternoon');
      } else {
        setGreeting('Good Evening');
      }
    };

    updateGreeting();
    
    // Optional: Update the greeting every minute
    const interval = setInterval(updateGreeting, 60000);

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    // <div className="App">
    //   {/* <BrowserRouter> */}
    //   <Routes>
    //     <Route path="/login" element={<Login />} />
    //     <Route path="/signup" element={<SignUp />} />
    //   </Routes>
    //   <Routes>
    //     <Route path="/" element={<Navigate to={'/dashboard'} />} />
    //     <Route path="/dashboard" element={<Layout component={<Dashboard />} />} />
    //     <Route path="/problem" element={<Layout component={<ProblemTable />} />} />
    //     <Route path="/patientproblem" element={<Layout component={<DocProblemTable />} />} />
    //     <Route path="/calender" element={<Layout component={<CalenderScreen />} />} />
    //     <Route
    //       path="/doctorappointment"
    //       element={<Layout component={<DoctorAppointmentTable />} />}
    //     />
    //     <Route
    //       path="/patientappointment"
    //       element={<Layout component={<PatientAppointmentTable />} />}
    //     />
    //     <Route
    //       path="/chat/:prbId/:senderId/:receiverId"
    //       element={<Layout component={<ChatScreen />} />}
    //     />
    //   </Routes>
    //   {/* </BrowserRouter> */}
    // </div>
    <div className="App">
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/patientcalendar" element={<PatientCalendar/> } />
        <Route path="/" element={<Navigate to={'/dashboard'} />} />
        <Route path="/dashboard" element={<Layout component={<Dashboard greeting={greeting}/>} />} />
        <Route path="/patients" element={<Layout component={<Patients />} />} />
        <Route path="/doctors" element={<Layout component={<Doctors />} />} />
        <Route path="/form" element={<Layout component={<PatientForm />} />} />
        <Route path="/appointment" element={<Layout component={<AppointmentPage />} />} />
        <Route path="/assessmentform" element={<Layout component={<AssesstmentForm />} />} />
        <Route path="/assessmentform/:id" element={<Layout component={<AssesstmentForm />} />} />
        <Route path="/docSpecialities" element={<Layout component={<DoctorSpecialities />} />} />
        <Route path="/additionalService" element={<Layout component={<AdditionalService />} />} />
        <Route path="/calenderPage" element={<Layout component={<AppointmentCalender />} />} />
        <Route path="/docAvailability" element={<Layout component={<DoctorUnavailability />} />} />
        <Route path="/expensePage" element={<Layout component={<ExpensePage />} />} />
        <Route path="/medicinePage" element={<Layout component={<Medicine />} />} />
        <Route path="/clinicPage" element={<Layout component={<Clinic />} />} />
        <Route path="/pharmacyPage" element={<Layout component={<PharmacyShop />} />} />
        <Route path="/importMedicine" element={<Layout component={<ImportMedicine />} />} />
        <Route path="/theme-settings" element={<Layout component={<ThemeSettings />} />} />
        <Route path="/patient-phi" element={<Layout component={<PatientPHIList />} />} />
        <Route path="/patient-phi/new" element={<Layout component={<PatientPHIForm />} />} />
        <Route path="/patient-phi/:id/edit" element={<Layout component={<PatientPHIForm />} />} />
        <Route path="/patient-phi/:id" element={<Layout component={<PatientPHIDetail />} />} />
        
        {/* <Route path="/problem" element={<Layout component={<ProblemTable />} />} /> */}
        {/* <Route path="/patientproblem" element={<Layout component={<DocProblemTable />} />} />
        <Route path="/calender" element={<Layout component={<CalenderScreen />} />} />
        <Route
          path="/doctorappointment"
          element={<Layout component={<DoctorAppointmentTable />} />}
        />
        <Route
          path="/patientappointment"
          element={<Layout component={<PatientAppointmentTable />} />}
        />
        <Route
          path="/chat/:prbId/:senderId/:receiverId"
          element={<Layout component={<ChatScreen />} />}
        /> */}
        <Route path="*" element={<Navigate to="/dashboard" />} /> {/* Default route */}
      </Routes>
    </div>
  );
}

export default App;
